export default __webpack_public_path__ + "static/021-c47d994bd4d713f5228d7e7477b96e27.jpg";